import Vue from 'vue'
import Vuex from 'vuex'
import Req from "owreq";
Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        user: {
            uid: "",
            unionid: "",
            city: "",
            province: "",
            sex: "",
            openid: "",
            owcode: "",
            icon: "",
            name: "",
            rkey: "",
            phone: "",
            last_points: 0,
            left_points: 0,
            all_points: 0,
            vip_left: 0,
            device_off_num: 0,
            device_on_num: 0,
            isAllLenvNas: false, // 是否联想渠道
            newUser: 0,
            newUserVip: 0
        },
        expandedKeys: [], //需要展开的节点id数据
        currentKey: null, //当前节点id
        client: "landing",
        chanid: "",
        refuid: "",
        version: ""
    },
    actions: {
        sendCode: function (store, [phone, cb]) {
            let data = {
                phone: phone,
                stamp: parseInt(new Date().getTime() / 1000),
            };
            Req.user.sendCode(data, cb);
        },
        sendUserlog: function (store, [type, msg, cb]) {
            let data = {
                uid: store.state.user.uid,
                pid: "",
                from: store.state.refuid,
                client: store.state.client,
                version: store.state.version,
                chan: store.state.chanid,
                type: type,
                msg: msg,
            };
            Req.user.log(data, cb);
            // TDAPP.onEvent(type);
        },
        phoneLogin: function (store, [phone, code, cb]) {
            let data = {
                phone: phone,
                answer: code,
                chanid: store.state.chanid,
                refuid: store.state.refuid,
                stamp: parseInt(new Date().getTime() / 1000),
            };
            Req.user.phoneLogin(data, cb);
        },
    }

})